import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Ticket } from '@models/ticket.model';

import { TableConfig } from '@app/shared/util/table-config.utils';
import { TranslateService } from '@ngx-translate/core';
import { TicketStatus } from "@models/enums/ticket-status";
import { Log } from "ng2-logger";

@Component({
    selector: 'app-tickets-table',
    templateUrl: './tickets-table.component.html',
    styleUrls: ['./tickets-table.component.scss']
})
export class TicketsTableComponent {
    _logger = Log.create(TicketsTableComponent.name);
    @Input() tickets: Ticket[] = [];
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() headerBackgroundColor: string;
    @Input() hasTitle = true;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() rowClick = new EventEmitter<any>();

    filterAutomaticList = [];
    filterStatusList = [];

    constructor(private translateService: TranslateService) {
        this.filterStatusList = this.buildStatusFilterColumnKeys();
        this.filterAutomaticList = this.buildAutomaticFilterColumnKeys();
        this.translateService.onLangChange.subscribe(() => {
            this.filterStatusList = this.buildStatusFilterColumnKeys();
            this.filterAutomaticList = this.buildAutomaticFilterColumnKeys();
            this._logger.info('onLangChange:: ', this.filterStatusList);
        });
    }

    onPageChange(tableConfig: TableConfig) {
        this._logger.info('onPageChange:: ', this.tableConfig);
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this._logger.info('onSortChange:: ', this.tableConfig);
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this._logger.info('onFilterChange:: ', this.tableConfig);
        this.filterChange.emit(tableConfig);
    }

    onStatusFilterChange(column: any, table: any) {
        if (column.filterValue === 'all' || column.filterValue === 'All') {
            column.filterValue = '';
        }
        table.onFilterChange(column);
    }

    onRowClick(clickedItem) {
        this._logger.info('onRowClick:: ', clickedItem);
        this.rowClick.emit(clickedItem);
    }

    private buildStatusFilterColumnKeys() {
        return [
            {name: this.translateService.instant("generic.statuses.all"), value: 'all'},
            {name: this.translateService.instant("generic.statuses.unavailable"), value: TicketStatus.UNAVAILABLE},
            {name: this.translateService.instant("generic.statuses.new"), value: TicketStatus.NEW},
            {name: this.translateService.instant("generic.statuses.ready"), value: TicketStatus.READY},
            {name: this.translateService.instant("generic.statuses.inProgress"), value: TicketStatus.IN_PROGRESS},
            {name: this.translateService.instant('generic.statuses.onHold'), value: TicketStatus.ON_HOLD},
            {name: this.translateService.instant("generic.statuses.closed"), value: TicketStatus.CLOSED},
        ];
    }

    private buildAutomaticFilterColumnKeys() {
        return [
            {name: this.translateService.instant("admin.tickets.table.isAutomatic.all"), value: null},
            {name: this.translateService.instant("admin.tickets.table.isAutomatic.false"), value: false},
            {name: this.translateService.instant("admin.tickets.table.isAutomatic.true"), value: true}
        ]
    }
}
